import { FormItem } from "../../../../base-data/area-building/model/form-item-interface";

// 标单顶部信息
export const PR_PO_CONTENT: FormItem[] = [
  { text: 'PRPOInfo.TypeProject', value: "itemdesc" },
  { text: 'PRPOInfo.PRNo', value: "purno" },
  { text: 'PRPOInfo.PRLine', value: "itemno" },
  { text: 'PRPOInfo.PONo', value: "pono" },
  { text: 'PRPOInfo.POLine', value: "poln" },
  { text: 'PRPOInfo.Vendor', value: "outsource" },
  { text: 'PRPOInfo.Buyer', value: "cusr" },
  { text: 'PRPOInfo.Price', value: "amnt" },
  { text: 'PRPOInfo.CompletionDate', value: "ddat" },
  { text: 'PRPOInfo.POAttachment', value: "poAttachment" },
];
